import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class UrlRewriteInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const apiUrl = environment.apiUrl;
    const modifiedUrl = `${apiUrl}/${request.url}`;
    const modifiedRequest = request.clone({ url: modifiedUrl });
    return next.handle(modifiedRequest);
  }
}
